import {
  FINISH_LESSON,
  FINISH_LESSON_SUCCESS,
  FINISH_LESSON_CLEAN,
  FINISH_LESSON_ERROR,
} from "./actionTypes"

const initialState = {
  error: "",
  loading: false,
  done: false,
  lesson: {},
}

const LessonFinish = (state = initialState, action) => {
  switch (action.type) {
    case FINISH_LESSON:
      state = {
        ...state,
        loading: true,
      }
      break
    case FINISH_LESSON_SUCCESS:
      state = {
        ...state,
        lesson: action.payload.lesson,
        loading: false,
        done: true,
      }
      break
    case FINISH_LESSON_CLEAN:
      state = initialState
      break
    case FINISH_LESSON_ERROR:
      state = { ...state, error: action.payload, loading: false, done: false }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default LessonFinish
